// Motion tokens — all animation constants live here.
// Import these; never write ad-hoc transition values directly in components.

export const duration = {
  instant: 0.08,
  fast: 0.16,
  base: 0.24,
  slow: 0.36,
  emphasized: 0.52,
};

export const easing = {
  standard: [0.2, 0, 0, 1],
  decelerate: [0, 0, 0, 1],
  emphasized: [0.3, 0, 0, 1],
  spring: {
    soft: { type: 'spring', stiffness: 180, damping: 22 },
    snappy: { type: 'spring', stiffness: 320, damping: 28 },
  },
};

// Framer-motion variants for page transitions.
// Reduced-motion: MotionConfig reducedMotion="user" at the app root collapses
// y-movement automatically; duration is shortened by the variant itself.
export const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
};

export const pageTransition = {
  duration: duration.base,
  ease: easing.standard,
};

// Stagger container + child variants.
// Cap total children at ~8 before falling through to a simple fade.
export const listContainerVariants = {
  animate: {
    transition: { staggerChildren: 0.045 },
  },
};

export const listItemVariants = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0, transition: easing.spring.soft },
};

// --- Auth screen animation tokens ---

export const auroraDrift = {
  duration: 18,
  ease: 'easeInOut',
};

// Soft spring card entrance with a small delay so the background settles first.
export const cardEntrance = {
  initial: { opacity: 0, y: 12, scale: 0.985 },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { ...easing.spring.soft, delay: 0.08 },
  },
};

// One-shot box-shadow + scale pulse for success feedback.
// scale is suppressed by MotionConfig reducedMotion="user" at the app root.
export const successPulse = {
  duration: 0.6,
  ease: easing.emphasized,
};

// Field shake for validation errors. scale is omitted — only x movement.
// Skipped entirely under reduced motion via the animate-only guard in AuthCard.
export const fieldShake = {
  x: [0, -6, 6, -4, 4, 0],
  transition: { duration: 0.4 },
};
